"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactPopper = require("react-popper");
var _useIsMobile = require("../../hooks/useIsMobile");
var _IconSliders = _interopRequireDefault(require("../../icons/General/IconSliders"));
var _Button = _interopRequireDefault(require("../Button"));
var _Divider = _interopRequireDefault(require("../Divider"));
var _Link = _interopRequireDefault(require("../Link"));
var _Text = _interopRequireDefault(require("../Text"));
var _styles = require("./styles");
var _bodyScrollLock = require("body-scroll-lock");
var _react2 = require("motion/react");
var _jsxRuntime = require("@emotion/react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/** @jsxImportSource @emotion/react */

const SearchFilter = ({
  title = 'Avansert søk',
  submitText = 'Søk',
  submitDisabled,
  children,
  hasFilters,
  placement = 'bottom',
  openButtonText,
  closeOnClear,
  onSubmit,
  onClear,
  onClose
}) => {
  const ref = /*#__PURE__*/(0, _react.createRef)();
  const isMobile = (0, _useIsMobile.useIsMobile)();
  const [open, setOpen] = (0, _react.useState)(false);
  const [popperElement, setPopperElement] = (0, _react.useState)(null);
  const [referenceElement, setReferenceElement] = (0, _react.useState)(null);
  const isCustomButton = Boolean(openButtonText);
  const popper = (0, _reactPopper.usePopper)(referenceElement, popperElement, {
    placement: placement,
    modifiers: [{
      name: 'offset',
      options: {
        offset: [0, 10]
      }
    }]
  });
  (0, _react.useEffect)(() => {
    const handleClickOutside = e => {
      const node = ref.current;
      if (node && node.contains(e.target)) {
        return;
      }
      handleClose();
    };
    if (open) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, ref]);
  (0, _react.useEffect)(() => {
    if (open) {
      (0, _bodyScrollLock.disableBodyScroll)(ref.current);
    } else if (ref?.current) {
      (0, _bodyScrollLock.enableBodyScroll)(ref.current);
    }
  }, [open, ref]);
  const handleClose = () => {
    setOpen(false);
    onClose && onClose();
  };
  const Content = (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [(0, _jsxRuntime.jsxs)(_styles.HeaderWrapper, {
      children: [(0, _jsxRuntime.jsx)(_Text.default, {
        bold: true,
        whiteSpace: "nowrap",
        children: title
      }), isMobile && (0, _jsxRuntime.jsx)(_Link.default, {
        removeUnderline: true,
        onClick: handleClose,
        children: "Lukk"
      })]
    }), (0, _jsxRuntime.jsx)(_Divider.default, {
      lightGray: true,
      margin: "0.5em"
    }), (0, _jsxRuntime.jsx)(_styles.ContentWrapper, {
      children: children
    }), onSubmit && (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [(0, _jsxRuntime.jsx)(_Divider.default, {
        lightGray: true,
        margin: "0.5em"
      }), (0, _jsxRuntime.jsxs)(_styles.ActionButtons, {
        children: [onClear && hasFilters && !isMobile && (0, _jsxRuntime.jsx)(_Link.default, {
          onClick: () => {
            onClear();
            if (closeOnClear) handleClose();
          },
          removeUnderline: true,
          children: "Nullstill"
        }), (0, _jsxRuntime.jsx)(_Button.default, {
          disabled: submitDisabled,
          onClick: () => {
            onSubmit && onSubmit();
            setOpen(false);
          },
          children: submitText
        })]
      })]
    })]
  });
  return (0, _jsxRuntime.jsxs)("div", {
    css: [_styles.styles.default(isCustomButton), hasFilters && !isCustomButton && _styles.styles.active, process.env.NODE_ENV === "production" ? "" : ";label:SearchFilter;"],
    ref: ref,
    children: [(0, _jsxRuntime.jsx)("div", {
      className: "open-button-wrapper",
      ref: setReferenceElement,
      children: (0, _jsxRuntime.jsx)(_Button.default, {
        nostyle: !isCustomButton,
        focusable: isCustomButton,
        outline: isCustomButton,
        onClick: open ? handleClose : () => setOpen(true),
        children: openButtonText ? openButtonText : (0, _jsxRuntime.jsx)(_IconSliders.default, {
          primary: true
        })
      })
    }), isMobile ? (0, _jsxRuntime.jsx)(_react2.AnimatePresence, {
      children: open && (0, _jsxRuntime.jsx)(_styles.Overlay, {
        initial: {
          opacity: 0
        },
        animate: {
          opacity: 1
        },
        exit: {
          opacity: 0
        },
        transition: {
          duration: 0.2
        },
        onClick: handleClose,
        children: (0, _jsxRuntime.jsx)(_styles.MobileWrapper, {
          onClick: e => e.stopPropagation(),
          initial: {
            y: '100%'
          },
          animate: {
            y: '0%'
          },
          exit: {
            y: '100%'
          },
          transition: {
            duration: 0.3,
            delay: 0.1,
            // Delay the entry animation
            ease: 'easeOut'
          },
          children: Content
        })
      })
    }) : open ? (0, _jsxRuntime.jsx)(_styles.PopperWrapper, {
      placement: placement,
      tabIndex: -1,
      role: "dialog",
      "aria-modal": "true",
      "aria-hidden": open,
      ref: setPopperElement,
      style: popper.styles.popper,
      ...popper.attributes.popper,
      children: Content
    }) : null]
  });
};
var _default = exports.default = SearchFilter;